import { HouseIcon } from '@components/Icons/HouseIcon';
import { LibraryIcon } from '@components/Icons/LibraryIcon';
import { SearchIcon } from '@components/Icons/SearchIcon';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import { ReactNode } from 'react';
import { NavItemId } from './navItems.shared';

/**
 * Keyed by a superset of `NavItemId`: it also carries `'agents'`, whose sparkle
 * icon is still reused by the Workspace "Ask AI" signpost even though Agents is
 * no longer a nav-rail row.
 */
type NavIconKey = NavItemId | 'agents';

/**
 * Single source of truth for the nav-rail icons. Anything that needs to match the
 * nav (e.g. the workspace signpost header icons) should read from here, so a
 * change to a nav icon (say, the Agents sparkles) updates everywhere at once.
 */
export const NAV_ICONS: Record<NavIconKey, ReactNode> = {
  workspace: <HouseIcon />,
  search: <SearchIcon />,
  libraries: <LibraryIcon />,
  podcasts: <PodcastsIcon />,
  customize: <TuneRoundedIcon />,
  schedule: <CalendarMonthRoundedIcon />,
  agents: <AutoAwesomeIcon />,
};
